import { useMemo } from 'react';
import { NsSelect } from 'components/common/ns-select/NsSelect';
import { range } from 'utils/misc';
import { useMaskPII } from 'hooks/useMaskPII';
import NsInputterEvent from 'components/common/ns-inputter/NsInputterEvent';

const START_DAY = 1;
const END_DAY = 28;

export const testId = 'paymentDateTestId';

type PaymentDateProps = {
  handleChange?: (event: NsInputterEvent) => void;
  value?: string;
};

export const PaymentDate = ({ handleChange, value }: PaymentDateProps) => {
  const days = range(START_DAY, END_DAY);
  const { unmask } = useMaskPII();

  return useMemo(() => {
    return (
      <NsSelect
        name="paymentDate"
        label="Choose a payment date"
        helper="About your payment date"
        tipDetail={`This is the date that your Direct Debit will be taken 
                    each month. If that date falls on a weekend or bank 
                    holiday, it will be taken the next working day.`}
        onChange={handleChange}
        value={value}
        inputAttributes={unmask}
        options={days.map((day) => ({ value: day }))}
      />
    );
  }, [days, unmask, handleChange, value]);
};
